export const CREATE_HIT = `mutation ($data: CreateHitInput!) {
  createHit(data: $data) {
    hashId
  }
}`
